import React from 'react';
import { LinearProgress } from '@material-ui/core';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import update from 'immutability-helper';
import VODListItem from './vodListItem';
import VODInfiniteList from './vodInfiniteList';
import VODDetail from './vodDetail';
import classnames from 'classnames';

const propTypes = {
  auth: PropTypes.object.isRequired,
  onClickCast: PropTypes.func,
  onClickProgram: PropTypes.func,
  onClickCategory: PropTypes.func,
  vodUpdate: PropTypes.func.isRequired,
  vodCastUpdate: PropTypes.func.isRequired,
  vodCategoryUpdate: PropTypes.func.isRequired,
  loadVOD: PropTypes.bool,
  vodMain: PropTypes.arrayOf(PropTypes.object).isRequired,
  vodCast: PropTypes.arrayOf(PropTypes.object).isRequired,
  vodCate: PropTypes.arrayOf(PropTypes.object).isRequired,
  vodDetail: PropTypes.arrayOf(PropTypes.object).isRequired,
}

const defaultProps = {
  onClickCast: null,
  onClickProgram: null,
  onClickCategory: null,
  auth: {},
  vodUpdate: null,
  vodCastUpdate: null,
  vodCategoryUpdate: null,
  vodDetailUpdate: null,
  loadVOD: false,
  vodMain: [],
  vodCast: [],
  vodCate: [],
  vodDetail: [],
}

class VODList extends React.Component<propTypes> {
  constructor(props) {
    super(props)
    this.state = {
      title: 'VOD',
      cast: '',
      cate: '',
      currentVOD: {},
      korCate: '',
      catePage: 1,
      step: 0,
      prevStep: -1,
      listTest: Array.from({ length: 30 })
    }
  }

  componentDidMount() {
    const { vodUpdate } = this.props
    vodUpdate(() => {
      // console.log('VOD MAIN LOAD - MOUNT') 
    })
  }

  handlerCastSelect = (cast: string) => {
    if (typeof this.props.onClickCast === 'function') {
      const { step } = this.state
      const { vodCastUpdate } = this.props
      vodCastUpdate(cast, () => {
        // console.log('VOD CAST LOAD - SELECT') 
      })
      this.props.onClickCast(cast)
      this.setState({ prevStep: step, title: cast, step: 1, cast: cast })
    }
  }

  handlerCategorySelect = (cat: string) => {
    if (typeof this.props.onClickCategory === 'function') {
      const { title, cast, catePage, step } = this.state
      const { vodCategoryUpdate } = this.props
      var engTitle = cat.replace(/[^a-zA-Z]/g, "")
      const pureTitle = cat.replace(/[^\uAC00-\uD7AF\u1100-\u11FF\u3130-\u318F-/]/gi, "")

      if (!engTitle) {
        engTitle = pureTitle.indexOf('일반') === 0 && 'Edu'
      }

      vodCategoryUpdate(cast, engTitle, catePage, () => {
        // console.log('VOD CATE LOAD - MORE') 
      })
      this.props.onClickCategory(engTitle)
      this.setState(update(this.state, {
        prevStep: { $set: step },
        cate: { $set: engTitle },
        title: { $set: title + '/' + pureTitle },
        step: { $set: 2 },
        korCate: { $set: pureTitle }
      }))
    }
  }

  handlerVODSelect = (program: string) => {
    if (typeof this.props.onClickProgram === 'function') {
      const { step } = this.state
      /**
       * VOD Detail Load API 필요
       */
      const { vodDetailUpdate } = this.props
      this.props.onClickProgram(program)
      vodDetailUpdate(program.idkey, () => {
        // console.log('VOD DETAIL LOAD - INIT') 
      })
      this.setState(update(this.state, {
        title: { $set: program.program },
        prevStep: { $set: step },
        step: { $set: 3 },
        currentVOD: { $set: program },
      }))
    }
  }

  handlerBack = () => {
    this.setState({
      currentVOD: {},
    })

    if (this.state.step === 0) {
      return
    } else if (this.state.step === 1) {
      const { vodUpdate } = this.props

      vodUpdate(() => {
        // console.log('VOD MAIN LOAD - BACK') 
      })

      this.setState({ title: 'VOD', step: 0, prevStep: 1 })
    } else if (this.state.step === 2) {
      const { vodCastUpdate } = this.props
      const { cast } = this.state

      vodCastUpdate(cast, () => {
        // console.log('VOD CAST LOAD - SELECT') 
      })

      this.setState({ title: cast, step: 1, catePage: 1, prevStep: 2 })
      this.props.onClickCast(cast)
    } else if (this.state.step === 3) {
      if (this.state.prevStep === 0) {
        const { vodUpdate } = this.props

        vodUpdate(() => {
          // console.log('VOD MAIN LOAD - BACK') 
        })

        this.setState({ title: 'VOD', step: 0 })
      } else if (this.state.prevStep === 1) {
        const { vodCastUpdate } = this.props
        const { cast } = this.state

        vodCastUpdate(cast, () => {
          // console.log('VOD CAST LOAD - SELECT') 
        })

        this.setState({ title: cast, step: 1, catePage: 1 })
        this.props.onClickCast(cast)
      } else if (this.state.prevStep === 2) {
        const { vodCategoryUpdate } = this.props
        const { cast, cate, catePage, korCate } = this.state

        vodCategoryUpdate(cast, cate, catePage, () => {
          // console.log('VOD CATE LOAD - MORE') 
        })

        this.setState(update(this.state, {
          title: { $set: cast + '/' + korCate },
          step: { $set: 2 },
        }))
        this.props.onClickProgram(cate)
      }
    }
  }

  loadMoreVOD = () => {
    const { cast, cate, catePage } = this.state
    const { vodCategoryUpdate } = this.props
    this.setState(update(this.state, { catePage: { $set: this.state.catePage + 1 } }),
      () => (
        vodCategoryUpdate(cast, cate, catePage, () => {
          // console.log('VOD CATE LOAD - MORE') 
        })
      )
    )
  }

  backURL = () => {
    const { step, prevStep, cast, cate } = this.state

    if (step === 0) {
      return '/player'
    }


    if (prevStep === 2) {
      return `/player/vod/${cast}?cate=${cate}`
    }

    if (prevStep === 1) {
      return `/player/vod/${cast}`
    }

    if (prevStep === 0) {
      return '/player/vod'
    }

    return '/player'
  }

  render() {
    const { vodMain, vodCast, vodCate, loadVOD, vodDetail } = this.props
    const { title, cast, cate, step, currentVOD } = this.state

    return (
      <>
        <div className={classnames('actionBar', { vod: step === 3 })}>
          <Link className="back" to={this.backURL()} onClick={this.handlerBack} replace />
          <div className="title">
            {title}
          </div>
        </div>
        {!loadVOD ? <LinearProgress color='secondary' /> :
          <div className="container">
            {step === 3 ? (
              <VODDetail
                currentVOD={currentVOD}
                vodList={vodDetail}
              />
            ) : (
                <div id="scroll-container" className="container-scroll">
                  {step === 0 && (
                    vodMain.map((vod, i) => {
                      return (
                        <VODListItem
                          onClickVOD={this.handlerVODSelect}
                          onClickMore={this.handlerCastSelect}
                          vod={vod}
                          key={i}
                        />
                      )
                    })
                  )}
                  {step === 1 && (
                    vodCast.map((vod, i) =>
                      <VODListItem
                        onClickMore={this.handlerCategorySelect}
                        onClickVOD={this.handlerVODSelect}
                        vod={vod}
                        key={i}
                      />
                    )
                  )}
                  {step === 2 && (
                    <VODInfiniteList
                      cast={cast}
                      cate={cate}
                      vod={vodCate}
                      loadMore={this.loadMoreVOD}
                      onClickVOD={this.handlerVODSelect}
                    />
                  )}
                </div>
              )}
          </div>
        }
      </>
    )
  }
}

VODList.propTypes = propTypes;
VODList.defaultProps = defaultProps;

export default VODList;
